export default [
  {
    path: '/',
    redirect: '/home',
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('views/home/HomePage'),
    meta: {
      index: 0,
      topIndex: 0,
    },
  },
  {
    path: '/search',
    name: 'AdvancedSearch',
    component: () => import('views/home/AdvancedSearch'),
  },
  {
    path: '/BookList',
    name: 'BookList',
    component: () => import('views/list/BookList'),
    meta: {
      topIndex: 1,
    },
  },
  {
    path: '/DataList',
    name: 'DataList',
    component: () => import('views/list/DataList'),
    meta: {
      topIndex: 2,
    },
  },
  {
    path: '/BookDetail',
    name: 'BookDetail',
    component: () => import('views/detail/BookDetail'),
    meta: {
      topIndex: 1,
    },
  },
  {
    path: '/DataDetail',
    name: 'DataDetail',
    component: () => import('views/list/DataDetail'),
    meta: {
      topIndex: 2,
    },
  },
  {
    path: '/PublisherDetail',
    name: 'PublisherDetail',
    component: () => import('views/home/PublisherDetail'),
  },
  {
    path: '/AboutUs',
    name: 'AboutUs',
    component: () => import('views/home/AboutUs'),
  },
  {
    path: '/Classify',
    name: 'Classify',
    component: () => import('views/home/ClassifyMenu'),
  },
  {
    path: '/BigData',
    name: 'BigData',
    component: () => import('views/home/BigData/BigData'),
  },
  {
    path: '/MyWorkbench',
    name: 'MyWorkbench',
    component: () => import('views/personal/MyWorkbench'),
    meta: {
      isPersonal: true,
    },
  },
  {
    path: '/MyProfile',
    name: 'MyProfile',
    component: () => import('views/personal/MyProfile'),
    meta: {
      isPersonal: true,
    },
  },
  {
    path: '/MyPassword',
    name: 'MyPassword',
    component: () => import('views/personal/MyPassword'),
    meta: {
      isPersonal: true,
    },
  },
  {
    path: '/MyRelation',
    name: 'MyRelation',
    component: () => import('views/personal/MyRelation'),
    meta: {
      isPersonal: true,
    },
  },
  {
    path: '/MyBookList',
    name: 'MyBookList',
    component: () => import('views/personal/MyBookList'),
    meta: {
      isPersonal: true,
    },
  },
  {
    path: '/MyBookListDetail',
    name: 'MyBookListDetail',
    component: () => import('views/personal/MyBookListDetail'),
    meta: {
      isPersonal: true,
    },
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('views/newLogin/login'),
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('views/newLogin/register'),
  },
  {
    path: '/pdf',
    name: 'PDF',
    component: () => import('views/pdf'),
  },
  {
    path: '/ebook',
    name: 'ebook',
    component: () => import('@/views/epub'),
    meta: {
      title: 'epub电子书阅读',
    },
  },
  {
    path: '/loading',
    name: 'Loading',
    component: () => import('views/loading'),
  },
]
